import * as React from 'react';
import Text from './Text';
import { TextFieldProps } from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const TextPass = (props: TextFieldProps) => {
  const [isHidden, setHidden] = React.useState(true);
  const type = isHidden ? 'password' : 'text';
  const handleClickShowPassword = () => {
    setHidden(!isHidden);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  const eye =  (
    <InputAdornment position='end'>
      <IconButton
        aria-label='toggle password visibility'
        onClick={handleClickShowPassword}
        onMouseDown={handleMouseDownPassword}>
        {isHidden ? <Visibility /> : <VisibilityOff />}
      </IconButton>
    </InputAdornment>
  );
  return <Text type={type} InputProps={{endAdornment: eye}} {...props} />;
};

export default TextPass;
